import { createReducer } from '../../../utilities';

import { scope } from '../../../../actions/app/other/mpp/league';
import {
    REQUEST_FETCH_MPP_ACTIVE_LEAGUES,
    SUCCESS_FETCH_MPP_ACTIVE_LEAGUES,
    FAIL_FETCH_MPP_ACTIVE_LEAGUES,
} from '../../../../actions/entities/league';

const initialMPPActiveLeaguesState = {
    id: null,
    info: {
        isFetching: false,
        lastAction: null,
        needRefresh: true,
        updatedAt: null,
        success: false,
        error: false,
    }
};

function request(state, action) {
    return {
        ...state,
        info: {
            isFetching: true,
            lastAction: action.type,
            needRefresh: false,
            updatedAt: null,
            success: false,
            error: false,
        }
    };
}

function success(state, action) {
    const { id, receivedAt, success } = action;
    return {
        ...state,
        id: id || state.id,
        info: {
            ...state.info,
            isFetching: false,
            needRefresh: false,
            updatedAt: receivedAt,
            success,
            error: false,
        }
    };
}

function fail(state, action) {
    const { error, type } = action;
    return {
        ...state,
        id: type === FAIL_FETCH_MPP_ACTIVE_LEAGUES ? null : state.id,
        info: {
            ...state.info,
            isFetching: false,
            needRefresh: false,
            success: false,
            error,
        }
    };
}

export default createReducer(initialMPPActiveLeaguesState, {
    [REQUEST_FETCH_MPP_ACTIVE_LEAGUES]: request,
    [SUCCESS_FETCH_MPP_ACTIVE_LEAGUES]: success,
    [FAIL_FETCH_MPP_ACTIVE_LEAGUES]: fail,
}, scope);



// WEBPACK FOOTER //
// ./src/reducers/app/other/mpp/activeLeagues.js